import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminSettings() {
  const [comingSoon, setComingSoon] = useState(false);
  useEffect(() => { api.get("/settings").then(r => setComingSoon(!!r.data.coming_soon_mode)); }, []);

  const toggle = async () => {
    const v = !comingSoon;
    try {
      await api.put("/settings", { coming_soon_mode: v });
      setComingSoon(v);
      toast.success(v ? "Coming Soon mode ON — public sees email capture" : "Coming Soon mode OFF — storefront live");
    } catch { toast.error("Update failed"); }
  };

  return (
    <div data-testid="admin-settings-page">
      <div className="eyebrow mb-2">Site</div>
      <h1 className="aperture-h1 text-4xl mb-10">Settings.</h1>
      <div className="bg-white p-8 rounded-sm border max-w-2xl" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <div className="flex items-center justify-between">
          <div>
            <div className="font-serif text-xl text-navy">Coming Soon Mode</div>
            <div className="text-sm text-navy/60 mt-1">When ON, public visitors see the email capture landing page instead of the storefront.</div>
          </div>
          <button onClick={toggle} data-testid="settings-coming-soon-toggle" className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 ${comingSoon ? "bg-gold" : "bg-navy/20"}`}>
            <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 ${comingSoon ? "translate-x-8" : "translate-x-1"}`} />
          </button>
        </div>
        <div className="mt-6 gold-hairline" />
        <div className="mt-6 text-xs text-navy/60 uppercase tracking-widest">Integrations</div>
        <div className="mt-3 space-y-2 text-sm">
          <div className="flex justify-between"><span>Stripe</span><span className="text-gold">Connected (Test Mode)</span></div>
          <div className="flex justify-between"><span>PayPal</span><span className="text-navy/50">Coming Soon — add API creds</span></div>
          <div className="flex justify-between"><span>Resend Email</span><span className="text-navy/50">MOCKED — add RESEND_API_KEY</span></div>
          <div className="flex justify-between"><span>Object Storage</span><span className="text-gold">Connected</span></div>
        </div>
      </div>
    </div>
  );
}
